import { forwardRef } from 'react';
import { useCombinedRefs } from 'Shared/util/custom-hooks';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';


const SlideTransition = forwardRef(({
  isOpen,
  children,
  enterDuration,
  exitDuration,
  enterDelay,
  exitDelay,
  className,
  maxHeight,
}, ref) => {
  const containerRef = useCombinedRefs(ref);

  const maxHeightValue = (maxHeight || (containerRef.current && `${containerRef.current.scrollHeight}px`) || '10000px');

  const defaultStyle = {
    overflow: 'auto',
  };

  const transitionStyles = {
    entering: {
      overflow: 'hidden',
      maxHeight: maxHeightValue,
      transition: `max-height ${enterDuration}ms cubic-bezier(0.52, 0.16, 0.24, 1) ${enterDelay}ms`,
    },
    entered: {
      maxHeight: maxHeightValue,
    },
    exiting: {
      overflow: 'hidden',
      maxHeight: '0px',
      transition: `max-height ${exitDuration}ms cubic-bezier(0.52, 0.16, 0.24, 1) ${exitDelay}ms`,
    },
    exited: {
      maxHeight: '0px',
    },
  };

  return (
    <Transition
      in={isOpen}
      timeout={{
        enter: (enterDuration + enterDelay),
        exit: (exitDuration + exitDelay),
      }}
    >
      {(state) => (
        <div
          ref={containerRef}
          className={className || ''}
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  );
});

export default SlideTransition;

SlideTransition.defaultProps = {
  enterDuration: 0,
  exitDuration: 0,
  enterDelay: 0,
  exitDelay: 0,
};

SlideTransition.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  enterDuration: PropTypes.number,
  exitDuration: PropTypes.number,
  enterDelay: PropTypes.number,
  exitDelay: PropTypes.number,
  className: PropTypes.string,
  maxHeight: PropTypes.string,
};
